import TvOffIcon from '@mui/icons-material/TvOff';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import { youtubeNativeRecentTransmissionsMessages } from './youtube-broadcasts.messages';

/** Badge indicating the YouTube Native station is offline. */
export function YoutubeOfflineChip() {
  return (
    <Chip
      icon={<TvOffIcon color="error" fontSize="small" />}
      label={<FormattedMessage {...youtubeNativeRecentTransmissionsMessages.offline} />}
      sx={(theme) => ({
        bgcolor: alpha(theme.palette.error.main, 0.15),
        border: `1px solid ${alpha(theme.palette.error.main, 0.3)}`,
        color: 'error.main',
        '& .MuiChip-label': {
          fontWeight: 700,
          textTransform: 'uppercase',
        },
      })}
    />
  );
}
